export default async function validateInitials(value?: string) {
  if (!value || value.length !== 4) {
    return 'Kürzel müssen aus vier Buchstaben bestehen.';
  }
  if (!/^[A-Z]{4,4}$/i.test(value)) {
    return 'Kürzel müssen aus vier Buchstaben bestehen.';
  }
}
